
import { CollectionLayout } from "../layouts/CollectionLayout";
import { applyCollectionQueryState } from "../filters/collectionQueryState";

export default {
  data() {
    return {
      dialogDelete: false,
      singleModel: new this.layout.collection.model(),
      singleModalOpen: false,
      singleModalBrandNew: false,
      deletingItem: null,
      stashedRoute: null,
      disableNew: null,
      initialLoadComplete: false,
    };
  },
  props: {
    layout: {
      type: CollectionLayout,
      required: true,
    },
    showModelActions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    editItem(itemId) {
      if (!this.layout.useModal)
        return this.$router.push({
          path: this.layout.collection.model.getRouteSingle(itemId),
        });

      this.singleModel = this.layout.collection.getItem(itemId);

      if (this.showModelActions && this.singleModel.getRouteSingle()) {
        this.stashedRoute = location.toString();
        history.pushState({}, null, this.singleModel.getRouteSingle());
      }

      this.singleModalOpen = true;
    },

    addNew() {
      if (this.layout.inlineEdit || this.layout.expansionEnabled) {
        const newRowModel = this.layout.collection.newItem();

        // Item expansion is handled in the table row component
      } else if (this.layout.useModal && !this.layout.navigateForNew) {
        this.singleModel = this.layout.collection.newItem();
        this.singleModalOpen = true;
        this.singleModalBrandNew = true;
      } else {
        this.$router.push({
          path: this.layout.collection.newItemRoute,
          query: this.layout.collection.newModelDefaultsForCollection,
        });
      }
    },

    restoreRoute() {
      if (!this.stashedRoute) return;

      history.pushState({}, null, this.stashedRoute);
      this.stashedRoute = null;
    },

    modalClosed() {
      this.restoreRoute();
      this.singleModalOpen = false;
      this.singleModalBrandNew = false;
    },

    cancelNew(modelId) {
      this.singleModel = null;
      if (
        !modelId ||
        (typeof modelId === "string" && modelId.indexOf("_") !== 0)
      )
        return;
      this.layout.collection.deleteItem(modelId);
    },

    deleteItem(itemId) {
      return this.layout.collection.deleteItem(itemId);
    },

    deleteItemInit(model) {
      if (this.showModelActions) {
        this.deletingItem = model;
        this.dialogDelete = true;
      } else {
        this.layout.collection.markItemForDeletion(model.id);
      }
    },

    restoreItem(model) {
      return this.layout.collection.restoreItem(model.id);
    },

    deleteItemConfirm() {
      this.deleteItem(this.deletingItem.id).then((res) => {
        this.closeDelete();
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    refresh() {
      this.layout.collection.forceFetch();
    },

    async saveInlineChanges() {
      try {
        await this.layout.collection.saveChangesInPlace();
      } catch (error) {
        // The collection recorded it and the alert above the button renders
        // `saveErrorMessage`. A 4xx refusal is fully handled by that; anything
        // else is a genuine fault, so it still escapes to the error reporter.
        if (!this.layout.collection.saveErrorIsRefusal) throw error;
      }
    },

    applyFilters() {
      this.layout.collection.applyStagedFilters();
    },

    clearFilters() {
      this.layout.collection.clearVisibleFiltersImmediately();
    },

    loadFilterSetState(state) {
      // A page that owns the URL -- the generated list page -- routes saved
      // state through the router so the result stays shareable and the back
      // button works, and opts into that by listening for load-filter-set.
      // Any other page has no such round trip, so apply straight to the
      // collection; without this the menu would appear to do nothing there.
      if (this.$listeners["load-filter-set"]) {
        this.$emit("load-filter-set", state);
        return;
      }

      this.layout.collection.clearFiltersExcept([]);
      this.layout.collection.dynamicFilterController.clear();
      this.layout.collection.resetQueryOptionsExcept([]);
      this.layout.collection.applyStagedFilters();

      applyCollectionQueryState(this.layout.collection, state);
    },
  },

  computed: {
    hasFiltersRow() {
      return (
        this.layout.collection.visibleFilters.length >
        (this.layout.enableDynamicFilters ? 0 : 1)
      );
    },
    filterSetsEnabled() {
      return this.layout.enableFilterSets;
    },
    filterSetScope() {
      return `${this.layout.modelType.typeSlug}:${this.layout.id}`;
    },
    hasFilterLead() {
      return (
        !!this.$slots["filter-actions"] ||
        this.filterSetsEnabled ||
        this.layout.enableDynamicFilters
      );
    },
    showLayoutComponent() {
      return (
        this.initialLoadComplete ||
        (!(this.layout.collection.loading && this.layout.collection.isEmpty) &&
          (!this.layout.hideWhenEmpty || !this.layout.collection.isEmpty))
      );
    },
    hasCollectionActions() {
      return (
        !this.disableNew ||
        !this.layout.noRefresh ||
        this.layout.collectionActionComponents.length > 0 ||
        this.$slots["collection-actions"] ||
        this.$scopedSlots["collection-actions"]
      );
    },
    showCollectionSaveActions() {
      return (
        (this.layout.inlineEdit || this.layout.ordinalField) &&
        this.showModelActions &&
        this.layout.collection.hasUnsavedChanges
      );
    },
    modalLayoutOpts() {
      return {
        disableFields: this.layout.disableFields,
      };
    },
  },

  watch: {
    "layout.collection.model": {
      immediate: true,
      handler() {
        this.disableNew =
          !this.layout.collection.model.userCanCreateNew() ||
          this.layout.collection.model.isReadonlyToUser() ||
          this.layout.noNew;
      },
    },
    "layout.collection.filterQueryValues": {
      handler() {
        this.layout.collection.setQueryOption("page", 1);
        this.layout.collection.fetchDebounced();
      },
    },
    "layout.collection.loading": {
      handler() {
        if (!this.layout.collection.loading) {
          this.initialLoadComplete = true;
        }
      },
    },
  },
};
